import {Injectable} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {SwissFieldBase} from '../swiss-forms/fields/swiss-field-base';

@Injectable({
    providedIn: 'root'
})
export class SwissFieldControlService {

    constructor() {
    }

    toFormGroup(swissFields: SwissFieldBase<any>[]): Promise<UntypedFormGroup> {
        return new Promise((resolve) => {
            const group: any = {};

            swissFields.forEach(swissField => {
                if (swissField && swissField.options && swissField.options.key) {
                    group[swissField.options.key] = swissField.options.required ? new UntypedFormControl(swissField.options.value || '', Validators.required)
                        : new UntypedFormControl(swissField.options.value || '');
                }
            });
            resolve(new UntypedFormGroup(group));
        });
    }
}
